<template>
  <div class="hStackable fullHeight" @mouseover="active = true" @mouseleave="active = false" :style="style()">
    <slot v-bind:active="active" />
  </div>
</template>

<script>
export default {
  props: ['width', 'height', 'background'],
  data: function() {
    return {
      active: false,
      mutableHeight: this.height,
      mutableWidth: this.width,
    };
  },
  methods: {
    style() {
      return {
        width: `${this.mutableWidth}%`,
        'max-height': `${this.mutableHeight}`,
        'background-color': `${this.background}`,
      };
    },
  },
  created() {
    this.$on('setHeight', h => (this.mutableHeight = h == 100 ? '80%' : '100%'));
  },
};
</script>

<style scoped>
.fullHeight {
  height: 100%;
  overflow: hidden;
  color: black;
  background-color: white;
  align-items: center;
  justify-content: center;
  transition: max-height 0.3s ease-out;
}

.hStackable {
  /* margin: 6px; */
  width: 100%;
}
.hStackable + .hStackable {
  margin-left: 12px;
}
</style>
